import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function Sponsors() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <PageCarousel />
      <section className="section-padding">
        <div className="container">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="section-title-header text-center mb-5">
                <h1 className="section-title">Our Sponsors</h1>
              </div>
            </div>
          </div>

          {/* ================= CATEGORY 1: PREMIER SPONSORS ================= */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 col-md-12">
              <div className="text-center mb-4">
                <h3 className="fw-bold px-3 py-1 d-inline-block" style={{ color: '#70b60a', borderBottom: '3px solid #70b60a', textTransform: 'uppercase', fontSize: '1.5rem', letterSpacing: '1px' }}>
                  <i className="fa-solid fa-crown me-2"></i>Premier Sponsors
                </h3>
              </div>
              
              <div className="row g-4 justify-content-center">
                {/* Premier Sponsor 1 */}
                <div className="col-md-6">
                  <div className="card h-100 shadow-sm border-0 text-center p-4" style={{ backgroundColor: '#fff', borderRadius: '12px', borderTop: '4px solid #70b60a' }}>
                    
                    <h5 className="fw-bold text-dark mt-2" style={{ fontSize: '1.1rem' }}>
                      Department of Computer Science and Engineering, LNMIIT
                    </h5>
                  </div>
                </div>

                {/* Premier Sponsor 2 */}
                <div className="col-md-6">
                  <div className="card h-100 shadow-sm border-0 text-center p-4" style={{ backgroundColor: '#fff', borderRadius: '12px', borderTop: '4px solid #70b60a' }}>
                    
                    <h5 className="fw-bold text-dark mt-2" style={{ fontSize: '1.1rem' }}>
                      Centre for Smart Healthcare and Social Innovations (C-SHSI), LNMIIT
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= CATEGORY 2: DIAMOND SPONSOR ================= */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 col-md-12">
              <div className="text-center mb-4">
                <h3 className="fw-bold px-3 py-1 d-inline-block" style={{ color: '#00b4d8', borderBottom: '3px solid #00b4d8', textTransform: 'uppercase', fontSize: '1.4rem', letterSpacing: '1px' }}>
                  <i className="fa-solid fa-gem me-2"></i>Diamond Sponsor
                </h3>
              </div>

              <div className="row justify-content-center">
                <div className="col-md-5">
                  <div className="card shadow-sm border-0 text-center p-4" style={{ backgroundColor: '#fff', borderRadius: '12px', borderTop: '4px solid #00b4d8' }}>
                    
                    <h5 className="fw-bold text-dark mt-2">IIT Jammu</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= CATEGORY 3: SILVER SPONSOR ================= */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 col-md-12">
              <div className="text-center mb-4">
                <h3 className="fw-bold px-3 py-1 d-inline-block" style={{ color: '#adb5bd', borderBottom: '3px solid #adb5bd', textTransform: 'uppercase', fontSize: '1.3rem', letterSpacing: '1px' }}>
                  <i className="fa-solid fa-medal me-2"></i>Silver Sponsor
                </h3>
              </div>

              <div className="row justify-content-center">
                <div className="col-md-5">
                  <div className="card shadow-sm border-0 text-center p-4" style={{ backgroundColor: '#fff', borderRadius: '12px', borderTop: '4px solid #adb5bd' }}>
                   
                    <h5 className="fw-bold text-dark mt-2">Techno Solutions, Jaipur</h5>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="card shadow-sm border-0 text-center p-4" style={{ backgroundColor: '#fff', borderRadius: '12px', borderTop: '4px solid #adb5bd' }}>
                   
                    <h5 className="fw-bold text-dark mt-2">CSK Information Technology Pvt. Ltd., Noida</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

         
        </div>
      </section>
    </div>
  );
}

export default Sponsors;